var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-button",
    {
      staticClass: "btn-effects",
      class: [_vm.size === "sm" ? "btn-size-sm" : "btn-size"],
      attrs: {
        to: _vm.to,
        variant: _vm.variant,
        size: _vm.size,
        block: _vm.block,
        disabled: _vm.disabled
      },
      on: { click: _vm.handleClick }
    },
    [
      _vm._t("default", function() {
        return [_vm._v("Button")]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }